import React, { useEffect, useRef } from 'react'
import '../../assets/css/section.css'
import MainVideo from '../../assets/images/myindici-logo1.png'
import footerlogo from '../../assets/images/indici-logo-footer.svg'
import { Col, Container, Row } from 'react-bootstrap'
import { Menu, MenuProps } from 'antd'
import { Link, useLocation } from 'react-router-dom'
interface Homeprops 
{
  activeMenuItem?:any,
  handleMenuItemClick?:any
}
const FooterArea1: React.FunctionComponent<Homeprops> = (props) =>  {
  type MenuItem = Required<MenuProps>['items'][number];
  function getItem(
    label: React.ReactNode,
    key?: React.Key | null,
    icon?: React.ReactNode,
  ): MenuItem {
    return {
      key,
      icon,
      label,
      className: props.activeMenuItem === key ? 'ant-menu-item-selected' : undefined,
      onClick: () => props.handleMenuItemClick(key),
    } as MenuItem;
  }
  const handleFooterScrolling=()=>{
  window.scrollTo(0, 0);
  }
  const itemsMenuAdmin: MenuItem[] = [
    getItem(<Link to="/our-story" onClick={handleFooterScrolling}>Our Story </Link>, 'Our Story'),
    getItem(<Link to="/features"  onClick={handleFooterScrolling}>Features</Link>, 'Features'),
    getItem(<Link to="/myindici-for-providers" onClick={handleFooterScrolling}>myindici For Providers</Link>,'MyIndici for Providers'),
    getItem(<Link to="/help-center"  onClick={handleFooterScrolling}>Help Centre</Link>, 'Help Centre'),
  ];
  const handleScroll = () => 
    {
    const targetId = location.hash.split('#')
    const element = document.getElementById(targetId[1]) 
    if (element)
    {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };
  const location = useLocation();
  useEffect(() => {
    handleScroll();
  }, [location]);


  const itemsMenuFeatures: MenuItem[] = [
    getItem(<Link to={`/features#appointment_booking`}>Appointment Booking</Link>, 'Appointment Booking'),
    getItem(<Link to={`/features#secure_messaging`} >Secure Messaging</Link>, 'Secure Messaging'),
    getItem(<Link to={`/features#virtual_consults`} >Virtual Consults</Link>, 'Virtual Consults'),
    getItem(<Link to={`/features#useful_reminders`} >Useful Reminders</Link>, 'Useful Reminders'),
    getItem(<Link to={`/features#online_payment`} >Online Payment</Link>, 'Online Payment'),
  ];
  const itemsMenuContactUs: MenuItem[] = [];
  return (
    <React.Fragment>
      <Container fluid className='footertop pt-4'>
        <Container className='footertop'>
          <Row className="footercol1" align="start">
            <Col sm={12} md={2} className=''>
            </Col>
            <Col sm={12} md={2} className='mb-3'>
              <img src={footerlogo} alt="images" className='w-75 w-md-100 lables' />
            </Col>
            <Col sm={6} md={2} className='mb-3'>
              <h5 className='lables'>Quick Links</h5>
              <Menu theme="dark" mode="vertical" 
              selectedKeys={[props.activeMenuItem]}
                items={itemsMenuAdmin} style={{ flex: 1, minWidth: 0 }}
                className='footermenuitems menu-text' />
            </Col>
            <Col className='footercol2' sm={6} md={2}>
              <h5 className='lables'>Features</h5>
              <Menu theme="dark" mode="vertical" defaultSelectedKeys={['1']} items={itemsMenuFeatures} style={{ flex: 1, minWidth: 0 }} className='footermenuitems menu-text' />
            </Col>
            <Col className='footercol4' sm={6} md={2} >
            </Col>
            <Col className='footercol3' sm={6} md={2}>
            </Col>
          </Row>
          <Row className='footercopyright m-3'>
            <Col>
              <p style={{ color: '#fff', paddingTop: '10px', paddingBottom: '10px', margin: '0px' }} className=''>
                ©2020 - 2023. All rights reserved by myindici.co.nz
              </p>
            </Col>
          </Row>
        </Container>
      </Container>
    </React.Fragment >
  )
}
export default FooterArea1